import { Typography } from '@tunasong/ui-lib'
import type { FC, ReactNode } from 'react'
import ratingStyles from '../option-rating.module.css'
import { useReorderAnimation } from '../use-reorder-animation.js'
import css from './grouped.module.css'

export interface GroupSectionProps {
  name: string
  status?: string
  /** The rows' display order, so a re-sort slides instead of jumping. */
  order: number[]
  children: ReactNode
}

/** One group of a grouped poll: a named region, so each album reads (and is announced) as its own question. */
export const GroupSection: FC<GroupSectionProps> = props => {
  const { name, status, order, children } = props
  const rowsRef = useReorderAnimation<HTMLDivElement>(order)

  return (
    <section aria-label={name} className={css.group}>
      <div className={css.groupHeader}>
        <Typography variant="subtitle2" component="h3">
          {name}
        </Typography>
        {status ? (
          <Typography variant="caption" color="textSecondary" aria-live="polite">
            {status}
          </Typography>
        ) : null}
      </div>
      <div ref={rowsRef} className={ratingStyles.rows}>
        {children}
      </div>
    </section>
  )
}
